import { useEffect } from 'react';
import { getFilterGroupDiagnostics, shouldRunFilterGroupDiagnostics } from '../utils';

import type { IFilterGroup, IFilterItemConfig } from '@intelligence/v3/filterCore/types';

interface IUseFilterGroupDiagnosticsOptions {
  items: IFilterItemConfig[];
  visibleItems: IFilterItemConfig[];
  filterGroups: IFilterGroup[];
}

export const useFilterGroupDiagnostics = (options: IUseFilterGroupDiagnosticsOptions): void => {
  const { items, visibleItems, filterGroups } = options;

  useEffect(() => {
    if (!shouldRunFilterGroupDiagnostics() || filterGroups.length === 0) {
      return;
    }

    const diagnostics = getFilterGroupDiagnostics({
      items,
      visibleItems,
      filterGroups,
    });

    if (!diagnostics) {
      return;
    }

    console.debug('[dbi] [Filter] filterGroups 配置诊断', diagnostics);
  }, [filterGroups, items, visibleItems]);
};
